// extracted by mini-css-extract-plugin
export default {"title":"LessonPopup_title__D4LoA","action":"LessonPopup_action__f0Vjj"};